<template>
  <form id="invoice-confirmation-form" class="form pt-3 pt-md-2 px-i">
    <div class="form-wrapper container-fluid">
      <CardForm
        section-title="Confirm Payment"
        class="mb-0">
        <div class="invoice-details-row">
          <div class="invoice-details-row-cell">
            <p class="invoice-details-row-cell-title">
              INVOICE#
            </p>
            <p>{{ invoiceNumber }}</p>
          </div>
          <div class="invoice-details-row-cell">
            <p class="invoice-details-row-cell-title">
              FAWTER#
            </p>
            <p>{{ fawterNumber }}</p>
          </div>
          <div class="invoice-details-row-cell">
            <p class="invoice-details-row-cell-title">
              DATE
            </p>
            <p>{{ invoiceDate | formatDateInNumeric(true) }}</p>
          </div>
          <div v-if="invoiceDueDate" class="invoice-details-row-cell">
            <p class="invoice-details-row-cell-title">
              DUE DATE
            </p>
            <p>{{ invoiceDueDate | formatDateInNumeric(true) }}</p>
          </div>
          <div v-if="customerName" class="invoice-details-row-cell">
            <p class="invoice-details-row-cell-title">
              CUSTOMER
            </p>
            <p>{{ customerName }}</p>
          </div>
          <div class="invoice-details-row-cell invoice-details-row-cell-negative-margin">
            <p class="invoice-details-row-cell-title">
              STATUS
            </p>
            <div class="status-indicator status-indicator-rectangular flex-grow-0 flex-grow-sm-1" :class="pillColorClass">
              {{ invoiceStatus }}
            </div>
          </div>
        </div>
        <PaymentDetailsTable
          :payment-method="invoice.ptm_payment_method"
          :payment-fees="invoice.payment_fees"
          :currency-iso-code="invoice.currency_iso_code"
          :pass-on-fawter-fee="invoice.pass_on_fawter_fee"
          :invoice-total="invoice.total" />
        <div class="form-card-group">
          <div class="form-card-group-item col-24 col-md-12">
            <ItemSelect
              v-model="invoiceReport.invoice_offline_payment_option"
              :items="confirmPaymentOptions"
              key-method="name"
              value-method="value"
              label="Method of Payment"
              name="invoice_report[invoice_offline_payment_option]"
              :shortened="false" />
          </div>
          <div class="form-card-group-item col-24 col-md-12">
            <TextInput
              :v-model="invoiceReport.transaction_reference"
              custom-label="Transaction Reference"
              name="invoice_report[transaction_reference]" />
          </div>
          <div class="form-card-group-item col-24">
            <ToggleButton
              :v-model="invoice.email_payment_confirmation"
              name="invoice[email_payment_confirmation]"
              label="Email Payment Confirmation"
              :default-checked="true" />
          </div>
        </div>
        <div class="invoice-confirm-payment">
          <button type="button" class="btn btn-primary ihjoz-button-big-size" @click="$emit('confirmInvoice', $event);">
            Confirm Payment
          </button>
        </div>
      </CardForm>
    </div>
  </form>
</template>

<script>
import CardForm from "@shared/components/UI/CardForm.vue";
import ToggleButton from "@shared/components/UI/ToggleButton.vue";
import TextInput from "@shared/components/UI/TextInput.vue";
import ItemSelect from "@shared/components/UI/ItemSelect.vue";
import PaymentDetailsTable from "../PaymentDetailsTable.vue";

export default {
  name: "ConfirmInvoiceSection",

  components: {
    PaymentDetailsTable,
    CardForm,
    ToggleButton,
    TextInput,
    ItemSelect
  },

  props: {
    invoice: { type: Object },
    invoiceNumber: { type: String },
    fawterNumber: { type: String },
    invoiceDate: { type: String },
    invoiceDueDate: { type: String },
    customerName: { type: String },
    currencyIsoCode: { type: String },
    invoiceStatus: { type: String },
    pillColorClass: { type: String }
  },

  data () {
    return {
      invoiceReport: { invoice_offline_payment_option: "Cash" }
    };
  },

  computed: {
    currencyMinimumDigits () {
      if (this.currencyIsoCode === "LBP") {
        return 0;
      } else {
        return 2;
      }
    },

    confirmPaymentOptions () {
      return [
        { name: "Cash", value: "Cash" },
        { name: "Credit Card", value: "Credit Card" },
        { name: "Cheque", value: "Cheque" },
        { name: "Complimentary", value: "Complimentary" }
      ];
    }
  }
};
</script>
